import { Component } from '@angular/core';
import * as _ from "lodash";
import { KPIS } from "./core/kpi-modules";
import { faBarcode } from "@fortawesome/free-solid-svg-icons/faBarcode";
import { faTachometerAlt } from "@fortawesome/free-solid-svg-icons/faTachometerAlt";
import { faBars } from "@fortawesome/free-solid-svg-icons/faBars";
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(private translate: TranslateService) {
    translate.addLangs(["en", "de"]); 
    translate.setDefaultLang('en');
    // const browserLang = translate.getBrowserLang();
    // translate.use(browserLang.match(/en|de/) ? browserLang : 'en');
  }
  switchLanguage(language: string) {
    this.translate.use(language);
  }
  title = 'Rainer-client';

  iconSize = "lg";

  kpis = _.filter(KPIS, (i => i.active));
  kpiKeys = _.keys(this.kpis);

  dashboardIcon = faTachometerAlt;
  rfidReadIcon = faBarcode;
  menuIcon = faBars;

}
